function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 32px;\n  color: #ffffff;\n  text-align: center;\n\n  ",
        " {\n    text-align: left;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #979fa8;\n  text-align: center;\n  padding-bottom: 10px;\n\n  ",
        " {\n    text-align: left;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: rgba(151, 159, 168, 1);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 130%;\n  letter-spacing: 0;\n  margin-top: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        '\n  padding: 24px 16px;\n  background-color: #191c32;\n  background-image: url("/images/footer.png");\n  background-size: cover;\n  background-position: right;\n  background-repeat: no-repeat;\n\n  ',
        " {\n    background-size: contain;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #000c13;\n  padding: 8px;\n  color: #979fa8;\n  a {\n    margin-bottom: 10px;\n    ",
        " {\n      margin-bottom: 0;\n    }\n  }\n  p {\n    text-align: center;\n    ",
        " {\n      text-align: right;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  a {\n    padding: 6px;\n    background-color: rgba(151, 159, 168, 0.32);\n    border-radius: 10px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Flex } from "../Box";
import { StyledFooter, StyledSocialLinks } from "./styles";
export var DexStyledTitle = styled.h1.withConfig({
    componentId: "sc-4d6fd073-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
export var DexStyledDescription = styled.h1.withConfig({
    componentId: "sc-4d6fd073-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
export var DexStyledSubdescription = styled.p.withConfig({
    componentId: "sc-4d6fd073-2"
})(_templateObject2());
export var DexStyledFooter = styled(StyledFooter).withConfig({
    componentId: "sc-4d6fd073-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
export var DexStyledUnderFooter = styled.div.withConfig({
    componentId: "sc-4d6fd073-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
export var DexStyledSocialLinks = styled(StyledSocialLinks).withConfig({
    componentId: "sc-4d6fd073-5"
})(_templateObject5());
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _objectWithoutProperties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    return /*#__PURE__*/ _jsxs(Flex, _objectSpread({}, props, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ _jsx(DexStyledFooter, {
                justifyContent: "center",
                children: /*#__PURE__*/ _jsx(Flex, {
                    flexDirection: "column",
                    width: [
                        "100%",
                        null,
                        "1200px;"
                    ],
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        flexDirection: [
                            "column",
                            null,
                            "row"
                        ],
                        justifyContent: "space-between",
                        alignItems: "start",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "info",
                                children: [
                                    /*#__PURE__*/ _jsx(DexStyledTitle, {
                                        children: "Stobox DS Swap"
                                    }),
                                    /*#__PURE__*/ _jsx(DexStyledDescription, {
                                        children: "Decentralized secondary market for security tokens"
                                    }),
                                    /*#__PURE__*/ _jsx(DexStyledSubdescription, {
                                        children: "Stobox DS Swap is operated by Stobox Innovations Limited, a company incorporated in the British Virgin Islands on the 11th day of May, 2022 under the BVI Business Companies Act, 2004, with BVI COMPANY NUMBER 2098354. Stobox DS Swap facilitates the trading of the STBX token, which is issued by Stobox Tokenized Equities Limited, a related company incorporated in the British Virgin Islands on the 7th day of December, 2023, under BVI Company Number 2137812. Both Stobox Innovations Limited and Stobox Tokenized Equities Limited are affiliated entities within the Stobox group of companies. Pursuant to the BVI Securities and Investment Business Act, 2010 (SIBA), Stobox DS Swap operates in compliance with the regulatory framework of the British Virgin Islands. Its activities are structured to facilitate the trading of tokenized assets issued solely by affiliated entities within the Stobox group, ensuring that no investment business license or brokerage license is required."
                                    }),
                                    /*#__PURE__*/ _jsx(DexStyledSubdescription, {
                                        children: "DS Swap is a purely technological solution designed to enable the trading of tokenized assets issued exclusively by entities within the Stobox group of companies.The platform is designed to support decentralized financial operations and complies with exemptions provided under the Markets in Crypto-Assets Regulation (MiCA), without performing functions subject to regulation under the Markets in Financial Instruments Directive (MiFID II). The platform does not engage in advertising or targeted marketing of financial instruments. Access to DS Swap may be restricted or unavailable in certain jurisdictions due to regulatory constraints."
                                    }),
                                    /*#__PURE__*/ _jsx(DexStyledSubdescription, {
                                        children: "By using Stobox DS Swap, you acknowledge that you have read, understood, and accepted these terms, and you assume full responsibility for ensuring compliance with your jurisdiction\u2019s laws and for any associated risks."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(DexStyledSocialLinks, {
                                order: [
                                    2
                                ],
                                pb: [
                                    "0",
                                    null,
                                    "0"
                                ],
                                mb: [
                                    "0",
                                    null,
                                    "0"
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(DexStyledUnderFooter, {
                children: /*#__PURE__*/ _jsxs(Flex, {
                    justifyContent: "space-between",
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    alignItems: "center",
                    width: "100%",
                    maxWidth: "1200px",
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            href: "/legal/termsofuse.pdf",
                            target: "_blank",
                            children: "Terms of Use"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            children: [
                                "\xa9 2018 - ",
                                new Date().getFullYear(),
                                " Stobox Group. All rights reserved."
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};
export default MenuItem;
